import React, { useState } from "react";
import { useQuery } from "react-query";
import { useParams } from "react-router-dom";
import moment from "moment";
import { useSnackbar } from "notistack";
import classNames from "classnames";

import IntervalBar from "components/IntervalBar/IntervalBarTrapinst";
import Charts from "./Charts";
import Tables from "./Tables";
import styles from "./_charts.module.scss";

import {
	getInstallationTodayData, getInstallationWeeklyData, getInstallationMonthlyData, getInstallationCustomData,
	useGetInstallations,
} from "service/RadarpestService";
import { getErrorMessage } from "service/Client";


export default function IntervalPageTrapinst({type, display}) {

	let { trapId } = useParams()
	const [interval, setInterval] = useState("weekly");
	const [startDate, setStartDate] = useState();
	const [endDate, setEndDate] = useState();
	const {enqueueSnackbar} = useSnackbar();
	let { installations } = useGetInstallations()

	let installationId = parseInt(trapId)

	function showError(e) {
		enqueueSnackbar(getErrorMessage(e), { variant: "error" });
	}

	let { data } = useQuery(['data', { trapId: installationId, interval, startDate, endDate }], () => {
		let promise
		
		if (!installationId) return;
		if (interval === "daily") {
			promise = getInstallationTodayData(installationId);
		} else if (interval === "weekly") {
			promise = getInstallationWeeklyData(installationId);
		} else if (interval === "monthly") {
			promise = getInstallationMonthlyData(installationId);
		} else if (startDate !== null && endDate !== null) {
			promise = getInstallationCustomData(installationId, startDate.format("DD-MM-YYYY"), endDate.format("DD-MM-YYYY"));
		}
		return promise
	}, {
		enabled: !!installationId && (interval !== 'custom' || (!!startDate && !!endDate)),
		initialData: [],
		onError: showError,
		refetchInterval: (interval === 'daily') ? 10000 : false,
	})

	if (!installationId) return null
	let installationObj = installations.find(a => a.id === installationId)
	if (!installationObj) return null

	return (
		<div className={classNames("animated", "fadeIn", styles.box)}>
			<IntervalBar
				minDate={installationObj.installationTime}
				maxDate={installationObj.removalTime}
				interval={interval}
				setInterval={setInterval}
				startDate={startDate}
				setStartDate={setStartDate}
				endDate={endDate}
				setEndDate={setEndDate}
				showDaily={false}
				showForecastBtn={false}
			/>

			{
				display === "charts" && <Charts data={data} type={type} />
			}
			{
				display === "table" && <Tables data={data} type={type} />
			}
		</div>
	);
}
